/**
 * Sidebar card explaining Stage Management — Sourcing-style card chrome.
 */

import { useTranslation } from 'react-i18next';
import { Check, Info, Layers } from 'lucide-react';
import { IconWrapper } from '@/components/ui/atoms/IconWrapper';
import { Typography } from '@/components/ui/atoms/Typography';

const ABOUT_POINTS = [
  'stage_management.about_point_view',
  'stage_management.about_point_rename',
  'stage_management.about_point_reorder',
  'stage_management.about_point_automations',
] as const;

export function StageManagementAboutCard() {
  const { t } = useTranslation('job');

  return (
    <aside className="flex flex-col rounded-xl border border-light-lila/60 bg-light p-5">
      <div className="flex flex-col items-center text-center">
        <IconWrapper
          size="xl"
          color="primary"
          ariaHidden
          className="rounded-lg bg-dark-invirtus-soft p-2.5"
        >
          <Layers />
        </IconWrapper>
        <Typography
          as="h3"
          variant="body-sm"
          weight="semibold"
          color="primary"
          className="mt-2.5"
        >
          {t('stage_management.about_title')}
        </Typography>
      </div>

      <Typography
        as="p"
        variant="body-xs"
        color="secondary"
        className="mt-2 text-center leading-relaxed"
      >
        {t('stage_management.about_intro')}
      </Typography>

      <ul className="mt-4 space-y-2.5 text-left">
        {ABOUT_POINTS.map((key) => (
          <li key={key} className="flex items-start gap-2.5">
            <IconWrapper size="sm" color="purple" ariaHidden className="mt-0.5">
              <Check />
            </IconWrapper>
            <Typography as="span" variant="body-sm" color="secondary">
              {t(key)}
            </Typography>
          </li>
        ))}
      </ul>

      <div className="mt-4 flex items-start gap-2.5 border-t border-light-lila/50 pt-4">
        <IconWrapper size="sm" color="secondary" ariaHidden className="mt-0.5">
          <Info />
        </IconWrapper>
        <Typography
          as="p"
          variant="body-xs"
          color="muted"
          className="leading-relaxed"
        >
          {t('stage_management.about_sot_note')}
        </Typography>
      </div>
    </aside>
  );
}
